export var Navigation;
(function (Navigation) {
    Navigation["NEXT"] = "NEXT";
    Navigation["PREVIOUS"] = "PREVIOUS";
})(Navigation || (Navigation = {}));
